import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import VueScrollTo from 'vue-scrollto';
import Vuebar from 'vuebar';
import 'froala-editor/js/plugins.pkgd.min';
import VueFroala from 'vue-froala-wysiwyg';
import VueMasonry from 'vue-masonry-css';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from 'huddlebv-plugin-axios';

import UserPlugin from './plugins/user';

/* Modules */
import cookiepopup from './modules/cookiepopup';
import quiz from './modules/quiz';
import poll from './modules/poll';
import modal from './modules/modal';

/* Models */
import Message from './models/Message';
import Thread from './models/Thread';
import Participant from './models/Participant';

Vue.use(Vuex);
Vue.use(Datetime);
Vue.use(VueScrollTo);
Vue.use(Vuebar);
Vue.use(VueMasonry);
Vue.use(VueFroala);
Vue.use(UserPlugin);

VuexORM.use(VuexORMAxios, {axios});

const database = new VuexORM.Database();

database.register(Message);
database.register(Thread);
database.register(Participant);

const state = {
	// Blog posts
	blogPost: [],
	emptyBlogImage: '',
	settings: '',
	translations: '',
	// huddle editor v2 vars
	active_editor_v2_uuid: false,
	plugins: '',
	//full screen search
	full_screen_search_open: false,
	search_results: {
		conversations: [],
		users: [],
		courses: [],
		lessons: [],
		boards: [],
	},
	showSpinner: false,
	creating_new_poll: false,
	//modal vars
	modalVisible: false,
	modalComponent: null,
	modalData: null,
	showModalButtons: true,
	modalSubmitEmit: false,
	modalAbortEmit: false,
	plugins: '',
	screen_width: 0,
};

const getters = {};


const mutations = {
	// Add posts to variable
	setBlogPosts(state, payload) {
		state.blogPost = payload;
	},

	setSettings(state, payload) {
		state.settings = payload;
	},

	setTranslations(state, payload) {
		state.translations = payload;
	},

	setPlugins(state, payload) {
		state.plugins = JSON.parse(payload);
	},

	// v2 editor active uuid
	setActiveEditorUUID(state, uuid) {
		state.active_editor_v2_uuid = uuid;
	},

	toggleFullScreenSearch(state) {
		state.full_screen_search_open = !state.full_screen_search_open;
	},

	setSearchResults(state, payload) {
		//define the array of items that we might receive from the backend
		let items = ['users', 'conversations', 'courses', 'lessons', 'boards'];

		//if we are adding more results to a specific item in the store
		if (payload.search_more) {
			//loop through the items
			for (let i = 0; i < items.length; i++) {
				//see if the item has any results
				if (payload.results[items[i]] && payload.results[items[i]].data.length > 0) {
					//loop through the results
					for (let y = 0; y < payload.results[items[i]].data.length; y++) {
						if (payload.results[items[i]].data[y] !== null && typeof payload.results[items[i]].data[y] !== 'undefined') {
							//add each result to the store
							state.search_results[items[i]].data.push(payload.results[items[i]].data[y]);
						}
					}
				}
			}
		} else {
			//update store with the results for each item
			for (let i = 0; i < items.length; i++) {
				if (payload.results[items[i]] && payload.results[items[i]].data.length > 0) {
					state.search_results[items[i]] = payload.results[items[i]];

					// filter out results that are null or undefined
					const indexes_to_filter = [];
					let amount_filtered = 0;

					for (let y = 0; y < state.search_results[items[i]].data.length; y++) {
						if (state.search_results[items[i]].data[y] === null || typeof state.search_results[items[i]].data[y] === 'undefined') {
							indexes_to_filter.push(y);
						}
					}

					for (let z = 0; z < indexes_to_filter.length; z++) {
						state.search_results[items[i]].data.splice(indexes_to_filter[z - amount_filtered], 1);
						amount_filtered++;
					}
				}
			}
		}
	},

	clearSearchResults(state) {
		state.search_results = {
			conversations: [],
			users: [],
			courses: [],
			lessons: [],
			boards: [],
		};
	},

	toggleSpinner(state, payload) {
		state.showSpinner = payload;
	},

	togglePollCreation(state, bool) {
		state.creating_new_poll = bool;
	},

	//modal mutations
	setModalData(state, settings) {
		if (settings.modalName) {
			state.modalComponent = settings.modalName;
			state.modalData = settings.modalData;

			//activate the modal
			state.modalVisible = true;
		}

		if (settings.modalSubmitEmit) {
			state.modalSubmitEmit = settings.modalSubmitEmit;
		}

		if (settings.modalAbortEmit) {
			state.modalAbortEmit = settings.modalAbortEmit;
		}

		if (settings.showModalButtons === false) {
			state.showModalButtons = settings.showModalButtons;
		}
	},

	hideModal(state) {
		state.modalVisible = false;
	},
	setScreenWidth(state, width) {
		state.screen_width = width;
	},
};

const actions = {
	getBlogPosts({commit}, payload) {
		// var user_id = payload;
		return axios.get('/blog-feed')
			.then(function (response) {
				commit('setBlogPosts', response.data);
			}).catch((response) => {

			});
	},

	//get settings
	getSettings({commit}, payload) {
		axios.get('/api/v3/settings')
			.then((response) => {
				commit('setSettings', response.data);
			}).catch((response) => {

			});
	},

	//get translations
	getTranslations({commit}, payload) {
		axios.get('/api/v3/settings?group=translations')
			.then((response) => {
				commit('setTranslations', response.data);
			}).catch((response) => {

			});
	},

	search(context, payload) {
		return new Promise((resolve, reject) => {
			axios.get('/api/v3/search', payload.request)
				.then((response) => {
					context.commit('setSearchResults', {
						results: response.data.results,
						search_more: payload.search_more
					});
					resolve(true);
				}, error => {
					reject(error);
				});
		});
	},

	storePoll(context, payload) {
		return new Promise((resolve, reject) => {
			axios.post('/api/v3/quiz-maker/quizzes/', payload).then((poll) => {

				let data = {};
				data.settings = [];

				Object.keys(payload.settings).map(function (key, index) {
					data.settings.push({
						'setting': key,
						'value': payload.settings[key]
					});
				});

				axios.post('/api/v3/quiz-maker/quizzes/' + poll.data.data.id + '/settings', data).then(() => {
					resolve(poll.data.data);
				});
			});
		});
	},

	storePollQuestion(context, payload) {
		return new Promise((resolve, reject) => {
			axios.post('/api/v3/quiz-maker/questions/', payload.question).then(function (response) {

				axios.post('/api/v3/quiz-maker/quizzes/' + payload.poll_id + '/questions', {questions: [response.data.data.id]})
					.then(() => {

					});

				resolve(response.data.data);
			});
		});
	},

	storePollQuestionOptions(context, payload) {
		return new Promise((resolve, reject) => {
			axios.post('/api/v3/quiz-maker/questions/' + payload.id + '/options', {question_options: payload.question_options})
				.then((response) => {
					resolve(response.data.data[0]);
				});
		});
	},

	storeImage(context, payload) {
		let form_data = new FormData();

		for (var key in payload) {
			if (key === 'file') {
				form_data.append('files[]', payload.file, payload.file.name);
			} else {
				form_data.append(key, payload[key]);
			}
		}

		return new Promise((resolve, reject) => {
			axios.post('/uploader', form_data).then(() => {
				resolve(true);
			}).catch(() => {
				reject();
			});
		});
	},

	removeImage(context, file_id) {
		return new Promise((resolve, reject) => {
			axios.delete('/uploader/' + file_id + '/delete').then(() => {
				resolve(true);
			});
		});
	},

	createTopic(context, data) {
		axios.post('/conversations/', data)
			.then(function (response) {
				window.location.href = '/conversations/' + response.data.instance_data.slug;
			});
	},

	completeLesson(context, id) {
		return new Promise((resolve) => {
			axios.post('/api/v3/content/' + id + '/complete').then((response) => {
				if (response.status === 200) {
					resolve(true);
				}
			}).catch(() => {
				alert('Content could not be completed. Try again later.');
			});
		});
	},
};

export default new Vuex.Store({
	plugins: [VuexORM.install(database, {namespace: 'db'})],
	modules: {
		cookiepopup,
		quiz,
		poll,
		modal,
	},
	state,
	mutations,
	actions,
	getters
});
